module.exports = __webpack_public_path__ + "img/nineLuckyBanner.15867db1.png";